import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from '@/router'

Vue.use(Vuex, VueAxios, axios);

// const URL_V1 = 'http://eposter-wall-api.entwicklung:8030/api/v1';
// const URL_V1 = 'http://eposter-api.entwicklung:8030/api/v1';
const URL_V1 = 'https://wcm2021.eposter.documedias.systems/api/v1';

const congress = process.env.VUE_APP_CONGRESS_DB;


export default new Vuex.Store({
  state: {
    _: {
      group: 'topic',
      grouped: 'topics',
      groupCapital: 'Topic',
      groupedCapital: 'Topics',
      title: 'WCM 2021 Virtual Meeting - ePoster'
    },
    login: {'enabled': false, authenticated: null, error: false},
    videoCheck: false,
    fullscreen: false,
    mode: {
      title: 'session',
      displayType: 'cards',
      grouped: {status: true, field: 'name', sort: 'asc', order: 'order', compact: false},
      order: 'presentation_code',
      sort: 'asc'
    },
    openCollapse: '',
    posters: [],
    poster: [],
    statistics: {},
    presentationSite: null,
    ratings: [],
    ratingstop5: [],
    loader: false,
    thumbnails: true,
  },
  actions: {
    GET_ALL_POSTERS: function ({commit}, mode) {
      let url = URL_V1 + '/gallery/poster/overview';
      url += '?grouped=' + mode.grouped.status;
      url += '&grouped_field=' + mode.grouped.field;
      url += '&grouped_sort=' + mode.grouped.sort;
      url += '&grouped_order=' + mode.grouped.order;
      url += '&order=' + mode.order;
      url += '&sort=' + mode.sort;
      axios.get(url).then((response) => {
        commit('SET_POSTERS', {posters: response.data})
      }, (err) => {
        // @todo handle this error
      })
    },
    GET_ALL_RATINGS: function ({commit}) {
      let url = URL_V1 + '/gallery/rating/overview';
      axios.get(url).then((response) => {
        commit('SET_RATINGS', {ratings: response.data})
      }, (err) => {
        // @todo handle this error
      })
    },
    GET_TOP5_RATINGS: function ({commit}) {
      let url = URL_V1 + '/gallery/rating/top/5';
      axios.get(url).then((response) => {
        commit('SET_RATINGSTOP5', {ratings: response.data})
      }, (err) => {
        // @todo handle this error
      })
    },
    getPosterById: function ({commit}, id) {
      return axios.get(URL_V1 + '/gallery/poster/detail/' + id);
    },
    GET_POSTERS: function ({commit, actions}, searchObject) {
      let url = URL_V1 + '/gallery/poster/overview';
      let mode = searchObject.mode;
      url += '?grouped=' + mode.grouped.status;
      url += '&grouped_field=' + mode.grouped.field;
      url += '&grouped_sort=' + mode.grouped.sort;
      url += '&grouped_order=' + mode.grouped.order;
      url += '&order=' + mode.order;
      url += '&sort=' + mode.sort;
      url += '&searchvalue=' + searchObject.search;
      axios.get(url).then((response) => {
        commit('SET_POSTERS', {posters: response.data})
      }, (err) => {
        // @todo handle this error
      })
    },
    GET_STATISTICS: function ({commit}) {
      axios.get(URL_V1 + '/gallery/statistics/overview').then((response) => {
        commit('SET_STATISTICS', {statistics: response.data})
      }, (err) => {
        // @todo handle this error
      })
    },
    GET_COMMENT: function ({}, id) {
      return axios.get(URL_V1 + '/gallery/comment/' + id);
    },
    CREATE_COMMENT: function ({commit, state, dispatch}, data) {
      return axios.post(URL_V1 + '/gallery/comment', data)
    },
    SET_RATING: function ({commit}, rating) {
      let url = URL_V1 + '/gallery/rating/rate/' + rating.poster_id + '/' + rating.rating;
      axios.post(url).then((response) => {
        commit('SET_RATINGS', {ratings: response.data})
      }, (err) => {
        // @todo handle this error
      })
    },
    SEND_MAIL_CONTACT: function ({commit}, mail) {
      let url = URL_V1 + '/gallery/mail/contact/' + mail.abstract_id;
      axios.post(url, mail).then((response) => {
      }, (err) => {
        // @todo handle this error
      })
    },
    SEND_LOGIN_CODE: function ({commit}, object) {
      let url = URL_V1 + '/login/code/' + congress;
      axios.post(url, object).then((response) => {
        let error = false;
        if (response.data.authenticated === false || response.data.error === true) {
          error = true;
        }
        commit('setAuthenticated', {value: response.data.authenticated})
        commit('setAuthError', {value: error})
        if (response.data.authenticated === true) {
          router.push('/home');
        }
      }, (err) => {
        // @todo handle this error
      })
    },
  },
  mutations: {
    SET_POSTERS: (state, {posters}) => {
      state.posters = posters;
      state.loader = false;
    },
    setPoster: (state, poster) => {
      state.poster = poster
    },
    SET_STATISTICS: (state, {statistics}) => {
      state.statistics = statistics
    },
    SET_RATINGS: (state, {ratings}) => {
      state.ratings = ratings;
    },
    SET_RATINGSTOP5: (state, {ratings}) => {
      state.ratingstop5 = ratings
    },
    setStarRating(state, payload) {
      state.ratings[payload.id].rating = payload.value;
    },
    setAuthenticated(state, status) {
      state.login.authenticated = status.value;
    },
    setAuthError(state, status) {
      state.login.error = status.value;
    }
  },
  getters: {
    poster: state => state.poster,
  },
  modules: {}
})
